<template>
    <div id="dashboard-container">
        <div id="scroll-buttons" v-if="shouldDisplayScrollButtons">
            <img src="../../assets/scroll-up.svg"
                 style="position: absolute; top:0; left:0; right:0; margin: auto;"
                 :width="canScrollUp ? '100%' : '50%'"
                 :style="{'cursor': canScrollUp ? 'pointer' : 'default'}"
                 :class="{'enabled-scroll-button': canScrollUp}"
                 @click="scrollUp">
            <img src="../../assets/scroll-down.svg"
                 style="position: absolute; bottom:48px; left:0; right:0; margin: auto;"
                 :width="canScrollDown ? '100%' : '50%'"
                 :style="{'cursor': canScrollDown ? 'pointer' : 'default'}"
                 :class="{'enabled-scroll-button': canScrollDown}"
                 @click="scrollDown">
        </div>
        <div id="dashboard" :style="{
                     'overflow-y': overflow,
                     'left': !shouldDisplayScrollButtons ? '0': '3.5%',
                     'width': !shouldDisplayScrollButtons ? '100%': '96.5%'}">

            <transition name="dashboard-item-fade-transition">
                <drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"
                      :transfer-data="riskScoreIndex">
                    <img class="drag-box" slot="image"
                         src="../../assets/dragdrop.png" width="400px"/>
                    <drop @drop="handleDrop(riskScoreIndex, ...arguments)">
                        <risk-score
                            :itemNumber="riskScoreIndex"
                            :class="dashboardItemClass(riskScoreIndex)"
                            v-show="shouldDisplayDashboardItem(riskScoreIndex)"
                            @loaded="widgetLoadedHandler"
                            :style="dashboardItemPosition(riskScoreIndex)"></risk-score>
                    </drop>
                </drag>
            </transition>

            <!--TODO this comment lines will be uncommented due to approval of threat time line widget-->
            <!--<transition name="dashboard-item-fade-transition">-->
            <!--<drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"-->
            <!--:draggable="draggableForThreatTimeLineIndex"-->
            <!--:transfer-data="threatTimeLineIndex">-->
            <!--<img class="drag-box" slot="image"-->
            <!--src="../../assets/dragdrop.png" width="400px"/>-->
            <!--<drop @drop="handleDrop(threatTimeLineIndex, ...arguments)">-->
            <!--<threat-time-line-->
            <!--:itemNumber="threatTimeLineIndex"-->
            <!--:class="dashboardItemClass(threatTimeLineIndex)"-->
            <!--v-show="shouldDisplayDashboardItem(threatTimeLineIndex)"-->
            <!--:style="dashboardItemPosition(threatTimeLineIndex)"-->
            <!--@enlargeClickedThreatTimeLine="threatTimeLineWidgetEnlargeHandler"></threat-time-line>-->
            <!--</drop>-->
            <!--</drag>-->
            <!--</transition>-->

            <transition name="dashboard-item-fade-transition">
                <drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset" v-show="hasPartners"
                      :transfer-data="partnerRiskScoreIndex">
                    <img class="drag-box" slot="image"
                         src="../../assets/dragdrop.png" width="400px"/>
                    <drop @drop="handleDrop(partnerRiskScoreIndex, ...arguments)">
                        <partner-risk-score
                            :itemNumber="partnerRiskScoreIndex"
                            :class="dashboardItemClass(partnerRiskScoreIndex)"
                            v-show="shouldDisplayDashboardItem(partnerRiskScoreIndex)"
                            @loaded="widgetLoadedHandler"
                            :style="dashboardItemPosition(partnerRiskScoreIndex)"></partner-risk-score>
                    </drop>
                </drag>
            </transition>

            <transition name="dashboard-item-fade-transition">
                <drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"
                      :transfer-data="malwareSoftwareEfficiencyIndex"
                >
                    <img class="drag-box" slot="image"
                         src="../../assets/dragdrop.png" width="400px"/>
                    <drop @drop="handleDrop(malwareSoftwareEfficiencyIndex, ...arguments)">
                        <malware-software-efficiency
                            :itemNumber="malwareSoftwareEfficiencyIndex"
                            :class="dashboardItemClass(malwareSoftwareEfficiencyIndex)"
                            v-show="shouldDisplayDashboardItem(malwareSoftwareEfficiencyIndex)"
                            @loaded="widgetLoadedHandler"
                            :style="dashboardItemPosition(malwareSoftwareEfficiencyIndex)"></malware-software-efficiency>
                    </drop>
                </drag>
            </transition>

            <transition name="dashboard-item-fade-transition">
                <drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"
                      :transfer-data="realtimeMalwareDetectionIndex">
                    <img class="drag-box" slot="image"
                         src="../../assets/dragdrop.png" width="400px"/>
                    <drop @drop="handleDrop(realtimeMalwareDetectionIndex, ...arguments)">

                        <realtime-malware-detection
                            :itemNumber="realtimeMalwareDetectionIndex"
                            :class="dashboardItemClass(realtimeMalwareDetectionIndex)"
                            v-show="shouldDisplayDashboardItem(realtimeMalwareDetectionIndex)"
                            @loaded="widgetLoadedHandler"
                            :style="dashboardItemPosition(realtimeMalwareDetectionIndex)"></realtime-malware-detection>
                    </drop>
                </drag>
            </transition>

            <!-- INFO: this component is commented out because if it is intended to be displayed again.-->
            <!--<transition name="dashboard-item-fade-transition">-->
                <!--<drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"-->
                      <!--:transfer-data="attackometerIndex">-->
                    <!--<img class="drag-box" slot="image"-->
                         <!--src="../../assets/dragdrop.png" width="400px"/>-->
                    <!--<drop @drop="handleDrop(attackometerIndex, ...arguments)">-->
                        <!--<attackometer-->
                            <!--:itemNumber="attackometerIndex"-->
                            <!--:class="dashboardItemClass(attackometerIndex)"-->
                            <!--v-show="shouldDisplayDashboardItem(attackometerIndex)"-->
                            <!--@loaded="widgetLoadedHandler"-->
                            <!--:style="dashboardItemPosition(attackometerIndex)"></attackometer>-->
                    <!--</drop>-->
                <!--</drag>-->
            <!--</transition>-->


            <!--<transition name="dashboard-item-fade-transition">-->
                <!--<drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"-->
                      <!--:transfer-data="malwareTimerIndex">-->
                    <!--<img class="drag-box" slot="image"-->
                         <!--src="../../assets/dragdrop.png" width="400px"/>-->
                    <!--<drop @drop="handleDrop(malwareTimerIndex, ...arguments)">-->
                        <!--<malware-timer-->
                            <!--:itemNumber="malwareTimerIndex"-->
                            <!--:class="dashboardItemClass(malwareTimerIndex)"-->
                            <!--v-show="shouldDisplayDashboardItem(malwareTimerIndex)"-->
                            <!--@loaded="widgetLoadedHandler"-->
                            <!--:style="dashboardItemPosition(malwareTimerIndex)"></malware-timer>-->
                    <!--</drop>-->
                <!--</drag>-->
            <!--</transition>-->


            <transition name="dashboard-item-fade-transition">
                <drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"
                      :transfer-data="targetedPhishingIndex">
                    <img class="drag-box" slot="image"
                         src="../../assets/dragdrop.png" width="400px"/>
                    <drop @drop="handleDrop(targetedPhishingIndex, ...arguments)">

                        <targeted-phishing
                            :itemNumber="targetedPhishingIndex"
                            :class="dashboardItemClass(targetedPhishingIndex)"
                            v-show="shouldDisplayDashboardItem(targetedPhishingIndex)"
                            @loaded="widgetLoadedHandler"
                            :style="dashboardItemPosition(targetedPhishingIndex)"></targeted-phishing>
                    </drop>
                </drag>
            </transition>

            <!-- INFO: this component is commented out because if it is intended to be displayed again.-->
            <!--<transition name="dashboard-item-fade-transition">-->
            <!--<drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"-->
            <!--:transfer-data="hourZeroPreventionTimelineIndex">-->
            <!--<img class="drag-box" slot="image"-->
            <!--src="../../assets/dragdrop.png" width="400px"/>-->
            <!--<drop @drop="handleDrop(hourZeroPreventionTimelineIndex, ...arguments)">-->

            <!--<hour-zero-prevention-timeline-->
            <!--:itemNumber="hourZeroPreventionTimelineIndex"-->
            <!--:class="dashboardItemClass(hourZeroPreventionTimelineIndex)"-->
            <!--v-show="shouldDisplayDashboardItem(hourZeroPreventionTimelineIndex)"-->
            <!--@loaded="widgetLoadedHandler"-->
            <!--:style="dashboardItemPosition(hourZeroPreventionTimelineIndex)"></hour-zero-prevention-timeline>-->
            <!--</drop>-->
            <!--</drag>-->
            <!--</transition>-->
            <!--INFO this comment lines may be uncommented due to approval of malware threat forecast widget-->
            <!--<transition name="dashboard-item-fade-transition">-->
            <!--<drag :image-x-offset="dragImageXOffset" :image-y-offset="dragImageYOffset"-->
            <!--:transfer-data="malwareThreatForecastIndex">-->
            <!--<img class="drag-box" slot="image"-->
            <!--src="../../assets/dragdrop.png" width="400px"/>-->
            <!--<drop @drop="handleDrop(malwareThreatForecastIndex, ...arguments)">-->
            <!--<malware-threat-forecast-->
            <!--:itemNumber="malwareThreatForecastIndex"-->
            <!--:class="dashboardItemClass(malwareThreatForecastIndex)"-->
            <!--v-show="shouldDisplayDashboardItem(malwareThreatForecastIndex)"-->
            <!--@loaded="widgetLoadedHandler"-->
            <!--:style="dashboardItemPosition(malwareThreatForecastIndex)"></malware-threat-forecast>-->
            <!--</drop>-->
            <!--</drag>-->
            <!--</transition>-->
        </div>
    </div>
</template>


<script>

    import RealtimeMalwareDetection from './realtime-malware-detection/RealtimeMalwareDetection.vue'
    import TargetedPhishing from './targeted-phishing/TargetedPhishing.vue'
    import MalwareThreatForecast from './malware-threat-forecast/MalwareThreatForecast.vue'
    import MalwareSoftwareEfficiency from './malware-software-efficiency/MalwareSoftwareEfficiency.vue'
    import Attackometer from './attackometer/Attackometer.vue'
    // import MalwareTimer from './malware-timer/MalwareTimer.vue'
    import RiskScore from './risk-score/RiskScore.vue'
    import PartnerRiskScore from './partner-risk-score/PartnerRiskScore.vue'
    import HourZeroPreventionTimeline from './hour-zero-prevention-timeline/HourZeroPreventionTimeline.vue'
    import ThreatTimeLine from './threat-timeline/ThreatTimeLine'
    import ThreatTimeLineMaximize from './threat-timeline/ThreatTimeLineMaximize'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'

    import {mapActions, mapGetters} from 'vuex';

    const SCROLL_STATE_INITIAL = 1;
    const SCROLL_STATE_SCROLLED_LVL_1 = 2;
    const SCROLL_STATE_SCROLLED_LVL_2 = 3;
    const SCROLL_STATE_SCROLLED_LVL_3 = 4;
    const SCROLL_STATE_SCROLLED_LVL_4 = 5;

    export default {
        name: "dashboard-page",
        components: {
            RealtimeMalwareDetection: RealtimeMalwareDetection,
            TargetedPhishing: TargetedPhishing,
            MalwareThreatForecast: MalwareThreatForecast,
            MalwareSoftwareEfficiency: MalwareSoftwareEfficiency,
            Attackometer: Attackometer,
            // MalwareTimer: MalwareTimer,
            RiskScore: RiskScore,
            PartnerRiskScore: PartnerRiskScore,
            HourZeroPreventionTimeline: HourZeroPreventionTimeline,
            ThreatTimeLine: ThreatTimeLine,
            ThreatTimeLineMaximize: ThreatTimeLineMaximize
        },
        mixins: [Common],
        data() {
            return {
                scrollState: SCROLL_STATE_INITIAL,
                realtimeMalwareDetectionIndex: 5,
                malwareSoftwareEfficiencyIndex: 4,
                // malwareThreatForecastIndex: 10,
                targetedPhishingIndex: 6,
                //attackometerIndex: 7,
                // malwareTimerIndex: 6,
                riskScoreIndex: 1,
                partnerRiskScoreIndex: -1,
                // INFO: this component is commented out because if it is intended to be displayed again.
                // hourZeroPreventionTimelineIndex: 4,
                threatTimeLineIndex: 3,
                dragImageXOffset: 200,
                dragImageYOffset: 130,
                application_version: null,
                applicationVersionFromBackend: null,
                partnersName: null,
                hasPartners: true,
                isDoubleWidgetShown: [],
                draggableForThreatTimeLineIndex: true,
                realtimeMalwareDetectionLoadDuration: null,
                targetedPhishingLoadDuration: null,
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // malwareThreatForecastLoadDuration: null,
                malwareSoftwareEfficiencyLoadDuration: null,
                // INFO: this component is commented out because if it is intended to be displayed again.
                //attackometerLoadDuration: null,
                // malwareTimerLoadDuration: null,
                riskScoreLoadDuration: null,
                partnerRiskScoreLoadDuration: null,
                // INFO: this component is commented out because if it is intended to be displayed again.
                // hourZeroPreventionTimelineLoadDuration: null
            }
        },
        methods: {
            threatTimeLineWidgetEnlargeHandler() {
                this.draggableForThreatTimeLineIndex = !this.draggableForThreatTimeLineIndex;
            },
            widgetLoadedHandler(widget_name, duration) {
                switch (widget_name) {
                    case 'realtime-malware-detection':
                        this.realtimeMalwareDetectionLoadDuration = duration;
                        break;
                    case 'targeted-phishing':
                        this.targetedPhishingLoadDuration = duration;
                        break;
                    // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                    // case 'malware-threat-forecast':
                    //     this.malwareThreatForecastLoadDuration = duration;
                    //     break;
                    case 'malware-software-efficiency':
                        this.malwareSoftwareEfficiencyLoadDuration = duration;
                        break;
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // case 'attackometer':
                    //     this.attackometerLoadDuration = duration;
                    //     break;
                    // case 'malware-timer':
                    //     this.malwareTimerLoadDuration = duration;
                    //     break;
                    case 'risk-score':
                        this.riskScoreLoadDuration = duration;
                        break;
                    case 'partner-risk-score':
                        this.partnerRiskScoreLoadDuration = duration;
                        break;
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // case 'hour-zero-prevention-timeline':
                    //     this.hourZeroPreventionTimelineLoadDuration = duration;
                    //     break;
                }

                if (this.allDurationsCompleted) {
                    let durations = [this.realtimeMalwareDetectionLoadDuration, this.targetedPhishingLoadDuration,
                        // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                        // this.malwareThreatForecastLoadDuration,
                        this.malwareSoftwareEfficiencyLoadDuration,
                        // INFO: this component is commented out because if it is intended to be displayed again.
                        //this.attackometerLoadDuration,
                        // this.malwareTimerLoadDuration,
                        this.riskScoreLoadDuration,
                        this.partnerRiskScoreLoadDuration == null ? 0 : this.partnerRiskScoreLoadDuration,
                        // INFO: this component is commented out because if it is intended to be displayed again.
                        // this.hourZeroPreventionTimelineLoadDuration
                    ];
                    let max = Math.max(...durations);
                    this.saveLog(this, 'Dashboard Page', 'Total Widget Load Duration Log', max, null);
                }
            },
            droppedAreaIndexHandler(droppedAreaIndex, draggedWidgetIndex) {
                if (this.realtimeMalwareDetectionIndex === droppedAreaIndex) {
                    this.setRealtimeMalwareDetectionIndex(draggedWidgetIndex);
                }
                else if (this.malwareSoftwareEfficiencyIndex === droppedAreaIndex) {
                    this.setMalwareSoftwareEfficiencyIndex(draggedWidgetIndex);
                }
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // else if (this.malwareThreatForecastIndex === droppedAreaIndex) {
                //     this.setMalwareThreatForecastIndex(draggedWidgetIndex);
                // }
                else if (this.targetedPhishingIndex === droppedAreaIndex) {
                    this.setTargetedPhishingIndex(draggedWidgetIndex);
                }
                // INFO: this component is commented out because if it is intended to be displayed again.
                // else if (this.attackometerIndex === droppedAreaIndex) {
                //     this.setAttackometerIndex(draggedWidgetIndex);
                // }
                // else if (this.malwareTimerIndex === droppedAreaIndex) {
                //     this.setMalwareTimerIndex(draggedWidgetIndex);
                // }
                else if (this.riskScoreIndex === droppedAreaIndex) {
                    this.setRiskScoreIndex(draggedWidgetIndex);
                }
                else if (this.partnerRiskScoreIndex === droppedAreaIndex) {
                    this.setPartnerRiskScoreIndex(draggedWidgetIndex);
                }
                // INFO: this component is commented out because if it is intended to be displayed again.
                // else if (this.hourZeroPreventionTimelineIndex === droppedAreaIndex) {
                //     this.setHourZeroPreventionTimelineIndex(draggedWidgetIndex);
                // }
            },
            draggedWidgetIndexHandler(droppedAreaIndex, draggedWidgetIndex) {
                if (this.realtimeMalwareDetectionIndex === draggedWidgetIndex) {
                    this.setRealtimeMalwareDetectionIndex(droppedAreaIndex);
                }
                else if (this.malwareSoftwareEfficiencyIndex === draggedWidgetIndex) {
                    this.setMalwareSoftwareEfficiencyIndex(droppedAreaIndex);
                }
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // else if (this.malwareThreatForecastIndex === draggedWidgetIndex) {
                //     this.setMalwareThreatForecastIndex(droppedAreaIndex);
                // }
                else if (this.targetedPhishingIndex === draggedWidgetIndex) {
                    this.setTargetedPhishingIndex(droppedAreaIndex);
                }
                // INFO: this component is commented out because if it is intended to be displayed again.
                // else if (this.attackometerIndex === draggedWidgetIndex) {
                //     this.setAttackometerIndex(droppedAreaIndex);
                // }
                // else if (this.malwareTimerIndex === draggedWidgetIndex) {
                //     this.setMalwareTimerIndex(droppedAreaIndex);
                // }
                else if (this.riskScoreIndex === draggedWidgetIndex) {
                    this.setRiskScoreIndex(droppedAreaIndex);
                }
                else if (this.partnerRiskScoreIndex === draggedWidgetIndex) {
                    this.setPartnerRiskScoreIndex(droppedAreaIndex)
                }
                // INFO: this component is commented out because if it is intended to be displayed again.
                // else if (this.hourZeroPreventionTimelineIndex === draggedWidgetIndex) {
                //     this.setHourZeroPreventionTimelineIndex(droppedAreaIndex);
                // }
            },
            synchronizeVuexToState() {
                this.realtimeMalwareDetectionIndex = this.getRealtimeMalwareDetectionIndex;
                this.malwareSoftwareEfficiencyIndex = this.getMalwareSoftwareEfficiencyIndex;
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // this.malwareThreatForecastIndex = this.getMalwareThreatForecastIndex;
                this.targetedPhishingIndex = this.getTargetedPhishingIndex;
                // INFO: this component is commented out because if it is intended to be displayed again.
                //this.attackometerIndex = this.getAttackometerIndex;
                // this.malwareTimerIndex = this.getMalwareTimerIndex;
                this.riskScoreIndex = this.getRiskScoreIndex;
                this.partnerRiskScoreIndex = this.getPartnerRiskScoreIndex;
                // INFO: this component is commented out because if it is intended to be displayed again.
                // this.hourZeroPreventionTimelineIndex = this.getHourZeroPreventionTimelineIndex;
                this.threatTimeLineIndex = this.getThreatTimeLineIndex;
            },
            checkDragAndDropForDoubledWidget(droppedAreaIndex, draggedWidgetIndex) {
                return false; // TODO: This line will be removed due to approvement of double widget
                if (this.threatTimeLineIndex === draggedWidgetIndex) {
                    /**
                     *  user dragged the doubled widget index
                     */
                    if (droppedAreaIndex < draggedWidgetIndex) {
                        /**
                         * doubled widget is at bottom
                         */
                        this.setThreatTimeLineIndex(draggedWidgetIndex - 2);
                        /**
                         * the remaining two widgets needs to swap places with
                         * doubled widget's old position
                         */
                        this.droppedAreaIndexHandler(draggedWidgetIndex - 1, draggedWidgetIndex - 2);
                        this.draggedWidgetIndexHandler(draggedWidgetIndex - 1, draggedWidgetIndex - 2);
                        this.droppedAreaIndexHandler(draggedWidgetIndex, draggedWidgetIndex - 1);
                        this.draggedWidgetIndexHandler(draggedWidgetIndex, draggedWidgetIndex - 1);
                        return true;
                    } else {
                        /**
                         * doubled widget is at top
                         */
                        this.setThreatTimeLineIndex(draggedWidgetIndex + 2);
                        /**
                         * the remaining two widgets needs to swap places with
                         * doubled widget's old position
                         */
                        this.droppedAreaIndexHandler(draggedWidgetIndex + 1, draggedWidgetIndex + 2);
                        this.draggedWidgetIndexHandler(draggedWidgetIndex + 1, draggedWidgetIndex + 2);
                        this.droppedAreaIndexHandler(draggedWidgetIndex, draggedWidgetIndex + 1);
                        this.draggedWidgetIndexHandler(draggedWidgetIndex, draggedWidgetIndex + 1);
                        return true;
                    }
                } else if (this.threatTimeLineIndex === droppedAreaIndex) {
                    if (droppedAreaIndex < draggedWidgetIndex) {
                        /**
                         * doubled widget is at top
                         */
                        this.setThreatTimeLineIndex(droppedAreaIndex + 2);
                        /**
                         * the remaining two widgets needs to swap places with
                         * doubled widget's old position
                         */
                        this.droppedAreaIndexHandler(droppedAreaIndex + 1, droppedAreaIndex + 2);
                        this.draggedWidgetIndexHandler(droppedAreaIndex + 1, droppedAreaIndex + 2);
                        this.droppedAreaIndexHandler(droppedAreaIndex, droppedAreaIndex + 1);
                        this.draggedWidgetIndexHandler(droppedAreaIndex, droppedAreaIndex + 1);
                        return true;
                    } else {
                        /**
                         * doubled widget is at bottom
                         */
                        this.setThreatTimeLineIndex(droppedAreaIndex - 2);
                        /**
                         * the remaining two widgets needs to swap places with
                         * doubled widget's old position
                         */
                        this.droppedAreaIndexHandler(droppedAreaIndex - 1, droppedAreaIndex - 2);
                        this.draggedWidgetIndexHandler(droppedAreaIndex - 1, droppedAreaIndex - 2);
                        this.droppedAreaIndexHandler(droppedAreaIndex, droppedAreaIndex - 1);
                        this.draggedWidgetIndexHandler(droppedAreaIndex, droppedAreaIndex - 1);
                        return true;
                    }
                }
            },
            handleDrop(droppedAreaIndex, draggedWidgetIndex) {
                if (draggedWidgetIndex === droppedAreaIndex) {
                    return;
                }
                if (!this.checkDragAndDropForDoubledWidget(droppedAreaIndex, draggedWidgetIndex)) {
                    this.droppedAreaIndexHandler(droppedAreaIndex, draggedWidgetIndex);
                    this.draggedWidgetIndexHandler(droppedAreaIndex, draggedWidgetIndex);
                }
                this.synchronizeVuexToState();

            },
            shouldDisplayDashboardItem: function (itemNumber) {
                return this.getDashboardEnlargedItem == null || this.getDashboardEnlargedItem == itemNumber;
            },
            scrollTop() {
                if (this.getResponsiveState != this.RESPONSIVE_SMALL) {
                    var elem = document.getElementById("dashboard");
                    if (elem)
                        elem.scrollTop = 0;
                }
            },
            scrollUp() {
                // TODO this comment lines will be uncommented due to approval of threat time line widget
                // if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_4) {
                //     this.scrollState = SCROLL_STATE_SCROLLED_LVL_3;
                // } else
                if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_3) {
                    this.scrollState = SCROLL_STATE_SCROLLED_LVL_2;
                } else if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_2) {
                    this.scrollState = SCROLL_STATE_SCROLLED_LVL_1;
                } else if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_1) {
                    this.scrollState = SCROLL_STATE_INITIAL;
                } else {
                    this.scrollState = SCROLL_STATE_INITIAL;
                }
                // TODO this comment lines will be uncommented due to approval of threat time line widget
                // this.computeDoubleWidgetShown();
            },
            scrollDown() {
                // TODO this comment lines will be uncommented due to approval of threat time line widget
                if (this.scrollState == SCROLL_STATE_INITIAL && this.hasPartners)
                    this.scrollState = SCROLL_STATE_SCROLLED_LVL_1;
                    // this.computeDoubleWidgetShown();
                // } else if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_1 ) {
                //     this.scrollState = SCROLL_STATE_SCROLLED_LVL_2;
                //     // this.computeDoubleWidgetShown();
                // }
                // INFO: this component is commented out because if it is intended to be displayed again.
                // else if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_2 && this.hasPartners) {
                //     this.scrollState = SCROLL_STATE_SCROLLED_LVL_3;
                //     // this.computeDoubleWidgetShown();
                // }
                // else if (this.scrollState == SCROLL_STATE_SCROLLED_LVL_3) {
                //     if (this.hasPartners){
                //         this.scrollState = SCROLL_STATE_SCROLLED_LVL_4;
                //         this.computeDoubleWidgetShown();
                //     }
                // }
            },
            computeDoubleWidgetShown() {
                let isDoubleWidgetShown = [];
                isDoubleWidgetShown[SCROLL_STATE_INITIAL] = false;
                isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_1] = false;
                isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_2] = false;
                isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_3] = false;
                isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_4] = false;
                if (this.threatTimeLineIndex == 1) {
                    isDoubleWidgetShown[SCROLL_STATE_INITIAL] = true;
                } else if (this.threatTimeLineIndex == 3) {
                    isDoubleWidgetShown[SCROLL_STATE_INITIAL] = true;
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_1] = true;
                } else if (this.threatTimeLineIndex == 5) {
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_1] = true;
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_2] = true;
                } else if (this.threatTimeLineIndex == 7) {
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_2] = true;
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_3] = true;
                } else if (this.threatTimeLineIndex == 9) {
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_3] = true;
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_4] = true;
                } else if (this.threatTimeLineIndex == 11) {
                    isDoubleWidgetShown[SCROLL_STATE_SCROLLED_LVL_4] = true;
                }
                this.isDoubleWidgetShown = isDoubleWidgetShown;
            },
            dashboardItemPosition(itemNumber) {
                if (this.getResponsiveState == this.RESPONSIVE_SMALL) {
                    return {
                        top: "unset",
                        left: "unset",
                        bottom: "unset",
                        right: "unset",
                        height: "500px !important"
                    }
                }

                // TODO this comment lines will be uncommented due to approval of threat time line widget
                if (false) {
                    // if (this.isDoubleWidgetShown[this.scrollState]) {
                    /**
                     * double widget will be shown on current scroll state
                     */
                    let topWidgetIndex = (this.scrollState * 2) - 1;
                    if (this.threatTimeLineIndex == topWidgetIndex) {
                        /**
                         * double widget will be shown on top
                         */
                        if (itemNumber == this.threatTimeLineIndex) {
                            /**
                             * get position of double widget
                             */
                            return {
                                top: "0%",
                                left: "0%",
                                bottom: "unset",
                                right: "unset",
                                width: "100%",
                                position: "absolute"
                            }
                        } else if (itemNumber == this.threatTimeLineIndex + 1) {
                            /**
                             * get position of bottom left widget
                             */
                            return {
                                top: "50.5%",
                                left: "0%",
                                bottom: "unset",
                                right: "unset",
                                position: "absolute"
                            }
                        } else if (itemNumber == this.threatTimeLineIndex + 2) {
                            /**
                             * get position of bottom right widget
                             */
                            return {
                                top: "50.5%",
                                left: "unset",
                                bottom: "unset",
                                right: "0%",
                                position: "absolute"
                            }
                        } else {
                            return {
                                top: "100%",
                                left: "unset",
                                bottom: "unset",
                                right: "unset",
                                position: "absolute"
                            }
                        }
                    } else {
                        /**
                         * double widget will be shown on bottom
                         */
                        if (itemNumber == this.threatTimeLineIndex) {
                            /**
                             * get position of double widget
                             */
                            return {
                                top: "50.5%",
                                left: "0%",
                                bottom: "unset",
                                right: "unset",
                                width: "100%",
                                position: "absolute"
                            }
                        } else if (itemNumber == this.threatTimeLineIndex - 2) {
                            /**
                             * get position of top left widget
                             */
                            return {
                                top: "0%",
                                left: "0%",
                                bottom: "unset",
                                right: "unset",
                                position: "absolute"
                            }
                        } else if (itemNumber == this.threatTimeLineIndex - 1) {
                            /**
                             * get position of top right widget
                             */
                            return {
                                top: "0%",
                                left: "unset",
                                bottom: "unset",
                                right: "0%",
                                position: "absolute"
                            }
                        } else {
                            return {
                                top: "100%",
                                left: "unset",
                                bottom: "unset",
                                right: "unset",
                                position: "absolute"
                            }
                        }
                    }
                } else {
                    /**
                     * double widget wont be shown on current scroll state
                     */
                    let startIndex = (2 * this.scrollState) - 1;
                    let isDoubleWidgetShownAtTop = false;
                    /**
                     * we need to calculate if double widget has been shown before or not,
                     * if double widget has shown before we need to reduce startIndex by 1,
                     * because double widget costs 2 widget area.
                     */
                    // TODO this comment lines will be uncommented due to approval of threat time line widget
                    // for (let i = this.scrollState; i >= SCROLL_STATE_INITIAL; i--) {
                    //     if (this.isDoubleWidgetShown[i]) {
                    //         isDoubleWidgetShownAtTop = true;
                    //         break;
                    //     }
                    // }
                    if (isDoubleWidgetShownAtTop) {
                        startIndex = startIndex - 1;
                    }
                    if (itemNumber == startIndex) {
                        /**
                         * get position of top left widget
                         */
                        return {
                            top: "0%",
                            left: "0%",
                            bottom: "unset",
                            right: "unset",
                            position: "absolute"
                        }
                    } else if (itemNumber == startIndex + 1) {
                        /**
                         * get position of top right widget
                         */
                        return {
                            top: "0%",
                            left: "unset",
                            bottom: "unset",
                            right: "0%",
                            position: "absolute"
                        }
                    } else if (itemNumber == startIndex + 2) {
                        /**
                         * get position of bottom left widget
                         */
                        return {
                            top: "49%",
                            left: "0%",
                            bottom: "unset",
                            right: "unset",
                            position: "absolute"
                        }
                    } else if (itemNumber == startIndex + 3) {
                        /**
                         * get position of bottom right widget
                         */
                        return {
                            top: "49%",
                            left: "unset",
                            bottom: "unset",
                            right: "0%",
                            position: "absolute"
                        }
                    } else {
                        return {
                            top: "100%",
                            left: "unset",
                            bottom: "unset",
                            right: "unset",
                            position: "absolute"
                        }
                    }
                }
            },
            dashboardItemClass(itemNumber) {
                var className = "";

                if (this.getResponsiveState === this.RESPONSIVE_BIG ||
                    this.getResponsiveState === this.RESPONSIVE_MIDDLE ||
                    this.getDashboardEnlargedItem == itemNumber) {
                    className = "dashboard-item dashboard-item-big " + className;
                }
                else if (this.getDashboardEnlargedItem && this.getDashboardEnlargedItem != itemNumber) {
                    className = "dashboard-item dashboard-item-small " + className;
                }
                else {
                    if (itemNumber == 1) {
                        className = "dashboard-item dashboard-item-small dashboard-item-stacked dashboard-item-small-no-margin " + className;
                    }
                    else {
                        className = "dashboard-item dashboard-item-small dashboard-item-stacked " + className;
                    }
                }

                // Add enlarged class if the item is enlarged
                if (this.getDashboardEnlargedItem == itemNumber) {
                    className += " dashboard-item-enlarge";
                }

                return className;
            },
            getApplicationVersionFromBackend() {
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/get_application_version';
                this.$http.get(path)
                    .then(response => {
                        this.applicationVersionFromBackend = response.data;
                        if (this.applicationVersionFromBackend != null) {
                            if (this.application_version == null) {
                                this.removeWidgetIndex();
                                this.setApplicationVersion(this.applicationVersionFromBackend.app_version);
                            }
                            else if (this.application_version != null) {
                                if (this.application_version === this.applicationVersionFromBackend.app_version) {
                                    return true;
                                }
                                else if (this.application_version != this.applicationVersionFromBackend.app_version) {
                                    this.removeWidgetIndex();
                                    this.setApplicationVersion(this.applicationVersionFromBackend);
                                }
                            }
                        }
                        else {
                        }
                        this.loading = false;
                    }, response => {
                        this.loading = false;
                    });
            },
            notificationsMenu() {
                this.setNotificationExtendable(false);
            },
            getPartners() {
                this.loading = true;
                this.$http.post(Constants.INTELLIGENCE_BACKEND_URL + '/enterprise/partners/get', {verbose: false}).then(response => {
                    this.partnersName = response.data.data;
                    if (this.partnersName.length == 0) {
                        this.hasPartners = false;
                        this.removeWidgetIndex();
                        // this.removeWidgetIndexForPartner();
                    }
                    else {
                        this.hasPartners = true;
                        this.removeWidgetIndexForPartner();
                        // this.removeWidgetIndex();

                    }
                    this.application_version = this.getApplicationVersion;
                    this.synchronizeVuexToState();
                }, response => {
                    this.loading = false;
                });
            },
            ...mapActions([
                "setRealtimeMalwareDetectionIndex",
                "setMalwareSoftwareEfficiencyIndex",
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // "setMalwareThreatForecastIndex",
                "setTargetedPhishingIndex",
                // INFO: this component is commented out because if it is intended to be displayed again.
                //"setAttackometerIndex",
                // "setMalwareTimerIndex",
                "setRiskScoreIndex",
                "setApplicationVersion",
                "setNotificationExtendable",
                "setPartnerRiskScoreIndex",
                // INFO: this component is commented out because if it is intended to be displayed again.
                // "setHourZeroPreventionTimelineIndex",
                "setThreatTimeLineIndex"
            ])
        },
        computed: {
            allDurationsCompleted() {
                let val = this.realtimeMalwareDetectionLoadDuration != null && this.targetedPhishingLoadDuration != null
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // && this.malwareThreatForecastLoadDuration != null
                    && this.malwareSoftwareEfficiencyLoadDuration != null
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // && this.attackometerLoadDuration != null
                    // && this.malwareTimerLoadDuration != null
                    && this.riskScoreLoadDuration != null;
                // INFO: this component is commented out because if it is intended to be displayed again.
                // && this.hourZeroPreventionTimelineLoadDuration != null;

                if (this.hasPartners) {
                    val = val && this.partnerRiskScoreLoadDuration != null;
                }

                return val;
            },
            overflow() {
                return this.getResponsiveState == this.RESPONSIVE_SMALL ? 'scroll' : 'hidden';
            },
            canScrollUp() {
                return this.scrollState == SCROLL_STATE_SCROLLED_LVL_1 || this.scrollState == SCROLL_STATE_SCROLLED_LVL_2
                    || this.scrollState == SCROLL_STATE_SCROLLED_LVL_3
                    || this.scrollState == SCROLL_STATE_SCROLLED_LVL_4;
            },
            canScrollDown() {
                if (this.hasPartners) {
                    return this.scrollState == SCROLL_STATE_INITIAL;
                    // INFO: this component is commented out because if it is intended to be displayed again.
                    // || this.scrollState == SCROLL_STATE_SCROLLED_LVL_2;
                    // TODO this comment lines will be uncommented due to approval of threat time line widget
                    // || this.scrollState == SCROLL_STATE_SCROLLED_LVL_3;
                }
            },
            shouldDisplayScrollButtons() {
                return !this.getDashboardEnlargedItem && this.getResponsiveState != this.RESPONSIVE_SMALL;
            },
            ...mapGetters([
                "getResponsiveState",
                "getDashboardEnlargedItem",
                "getRealtimeMalwareDetectionIndex",
                "getMalwareSoftwareEfficiencyIndex",
                // INFO this comment lines may be uncommented due to approval of malware threat forecast widget
                // "getMalwareThreatForecastIndex",
                "getTargetedPhishingIndex",
                // INFO: this component is commented out because if it is intended to be displayed again.
                // "getAttackometerIndex",
                // "getMalwareTimerIndex",
                "getRiskScoreIndex",
                "getApplicationVersion",
                "getNotificationExtendable",
                "getPartnerRiskScoreIndex",
                // INFO: this component is commented out because if it is intended to be displayed again.
                // "getHourZeroPreventionTimelineIndex",
                "getThreatTimeLineIndex"
            ])
        },
        watch: {},
        mounted() {
        },
        beforeMount() {
            this.synchronizeVuexToState();
            this.getPartners();
            this.computeDoubleWidgetShown();
            // this.realtimeMalwareDetectionIndex = this.getRealtimeMalwareDetectionIndex;
            // this.malwareSoftwareEfficiencyIndex = this.getMalwareSoftwareEfficiencyIndex;
            // this.malwareThreatForecastIndex = this.getMalwareThreatForecastIndex;
            // this.targetedPhishingIndex = this.getTargetedPhishingIndex;
            // this.attackometerIndex = this.getAttackometerIndex;
            // this.malwareTimerIndex = this.getMalwareTimerIndex;
            // this.riskScoreIndex = this.getRiskScoreIndex;
            // this.partnerRiskScoreIndex = this.getPartnerRiskScoreIndex;
            // this.application_version = this.getApplicationVersion;
            this.notificationsMenu();
            // this.getApplicationVersionFromBackend();
            // this.getPartners();
        }
    }

</script>

<style scoped>

    #dashboard-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    #dashboard {
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        transition: all .5s ease;
    }

    #scroll-buttons {
        width: 2.5%;
        height: calc(100% - 20px);
        position: absolute;
        left: 0;
        top: 10px;
    }

    .enabled-scroll-button {
        animation-duration: 2s;
        animation-name: heartbeat;
        animation-iteration-count: infinite;
    }

    .dashboard-item {
        transition: all .5s ease;
        background-color: black;

        background-clip: content-box;
        padding-right: 0;
        position: absolute;
        width: 49.6%;
        overflow: hidden;
    }

    .dashboard-item-stacked {
        transition: all .5s ease;
        position: relative !important;
        width: 100%;
    }

    .dashboard-item-big {
        transition: all .5s ease;
        height: 47%;
    }

    .dashboard-item-small {
        transition: all .5s ease;
        height: 48%;
        margin-top: 10px;
        min-height: 450px;
    }

    .dashboard-item-small-no-margin {
        margin-top: 0;
    }

    .dashboard-item-enlarge {
        transition: all .5s ease;
        width: 100%;
        height: 95%;
        position: absolute;
        z-index: 90;
        top: 0 !important;
    }

    .dashboard-item-top-right {
        top: 0;
        right: 0;
    }

    .dashboard-item-top-left {
        top: 0;
        left: 0;
    }

    .dashboard-item-bottom-left {
        bottom: 0;
        left: 0;
    }

    .dashboard-item-bottom-right {
        bottom: 0;
        right: 0;
    }

    .dashboard-item-third-row-left {
        top: 100%;
    }

    .dashboard-item-fade-transition-enter-active {
        transition: opacity .5s
    }

    .dashboard-item-fade-transition-leave-active {
        transition: opacity .5s
    }

    .dashboard-item-fade-transition-enter, .dashboard-item-fade-transition-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0
    }

    @keyframes heartbeat {
        0% {
            transform: scale(.8);
        }
        20% {
            transform: scale(1);
        }
        40% {
            transform: scale(.8);
        }
        60% {
            transform: scale(1);
        }
        80% {
            transform: scale(.8);
        }
        100% {
            transform: scale(.8);
        }
    }

    .drag-box {
        cursor: help;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/DashboardPage.vue